import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-breadcrumb',
    standalone: true,
    imports: [CommonModule, RouterModule],
    template: `
      <div class="ad-breadcrumb-title">
          <h4 class="semibold">{{ title }}</h4>
      </div>
  `,
    styles: []
})
export class BreadcrumbComponent {
    @Input() title: string = '';
    @Input() items: string[] = [];
    @Input() active_item: string = '';
}

// <div class="container-fluid">
// <div class="page-title">
//   <div class="row">
//     <div class="col-sm-6">
//       <h3>{{ title }}</h3>
//     </div>
//     <div class="col-sm-6">
//       <ol class="breadcrumb">
//         <li class="breadcrumb-item">
//           <a [routerLink]="['/']">
//             <i class="fa fa-home"></i>
//           </a>
//         </li>
//         @for (item of items; track $index) {
//           <li class="breadcrumb-item">{{ item }}</li>
//         }
//         @if (active_item) {
//           <li class="breadcrumb-item active">{{ active_item }}</li>
//         }
//       </ol>
//     </div>
//   </div>
// </div>
// </div>